import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { InviteSearchSchema } from './-zod-schema';

export const Route = createFileRoute('/_staff/settings/persons/invite/')({
  validateSearch: zodValidator(InviteSearchSchema),
});
